import { concat } from 'ramda';
import { inventoryManagementApi } from '../inventoryManagementApi';

const getUrl = concat('auto-reconsignments/');

const reconsignmentEndpoints = inventoryManagementApi.injectEndpoints({
  endpoints: ({ mutation, query }) => ({
    createAutoReconsignment: mutation({
      invalidatesTags: ['AutoReconsignments', 'AutoReconsignment'],
      query: ({ body }) => ({
        body,
        method: 'POST',
        url: getUrl('create-auto-reconsignment'),
      }),
    }),
    deleteReconsignment: mutation({
      invalidatesTags: ['AutoReconsignments'],
      query: ({ body }) => ({
        body,
        method: 'POST',
        url: getUrl('delete-auto-reconsignment'),
      }),
    }),
    editAutoReconsignment: mutation({
      invalidatesTags: ['AutoReconsignments', 'AutoReconsignment'],
      query: ({ body }) => ({
        body,
        method: 'POST',
        url: getUrl('edit-auto-reconsignment'),
      }),
    }),
    getAutoReconsignment: query({
      providesTags: ['AutoReconsignment'],
      query: ({ params }) => ({
        keepUnusedDataFor: 10,
        params,
        url: getUrl('edit-auto-reconsignment'),
      }),
    }),
    getAutoReconsignmentfromLocations: query({
      providesTags: ['AutoReconsignments'],
      query: ({ params }) => ({
        keepUnusedDataFor: 10,
        params,
        url: getUrl('get-auto-reconsignment-from-locations'),
      }),
    }),
    getAutoReconsignments: query({
      keepUnusedDataFor: 10,
      providesTags: ['AutoReconsignments'],
      query: ({ params }) => ({
        params,
        url: getUrl('get-auto-reconsignments'),
      }),
    }),
    viewAutoReconsignment: query({
      keepUnusedDataFor: 10,
      providesTags: ['AutoReconsignment'],
      query: ({ params }) => ({
        method: 'GET',
        params,
        url: getUrl('view-auto-reconsignment'),
      }),
    }),
  }),
});

// eslint-disable-next-line import/prefer-default-export
export const {
  useCreateAutoReconsignmentMutation,
  useDeleteReconsignmentMutation,
  useEditAutoReconsignmentMutation,
  useGetAutoReconsignmentQuery,
  useGetAutoReconsignmentfromLocationsQuery,
  useLazyGetAutoReconsignmentsQuery,
  useViewAutoReconsignmentQuery,
} = reconsignmentEndpoints;
